import { LIST_GC_TIME_MS, LIST_STALE_TIME_MS, useApiClient } from '@klareospace/pharos-lib-front-utils';
import type { PaginatedResponse, VehicleWithResolvedRefs } from '@klareospace/pharos-lib-types';
import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { SearchVehiclesParams } from '../api';
import { createVehicleApi, vehicleKeys } from '../api';

// ─── Types ────────────────────────────────────────────────────────────────────

interface UseVehiclesOptions extends SearchVehiclesParams {
  enabled?: boolean;
}

// ─── Hook ─────────────────────────────────────────────────────────────────────

export function useVehicles(options?: UseVehiclesOptions): UseQueryResult<PaginatedResponse<VehicleWithResolvedRefs>> {
  const client = useApiClient('admin-auth');
  const api = createVehicleApi(client);

  const { enabled, ...filters } = options ?? {};

  return useQuery({
    enabled,
    gcTime: LIST_GC_TIME_MS,
    queryFn: (): Promise<PaginatedResponse<VehicleWithResolvedRefs>> => api.searchVehicles(filters),
    queryKey: vehicleKeys.list(filters),
    staleTime: LIST_STALE_TIME_MS,
  });
}
